module.exports = __webpack_public_path__ + "img/hero-top-left.9cff50b0.svg";